import { useEffect, useState } from 'react';

type UsePaginateProps<T> = {
    items: T[];
    pageNumber: number;
    itemsPerPage: number;
} & (
    | {
          filter: (item: T, searchText: string) => boolean;
          searchText: string;
      }
    | {
          filter?: never;
          searchText?: never;
      }
);

export const usePaginate = <T>({
    items,
    pageNumber,
    itemsPerPage,
    searchText,
    filter,
}: UsePaginateProps<T>): [T[], number] => {
    const [pagedItems, setPagedItems] = useState<T[]>([]);
    const [pageCount, setPageCount] = useState(1);

    const selectPage = () => {
        const itemsFiltered = filter ? items.filter((item) => filter(item, searchText)) : items;
        const startPosition = (pageNumber - 1) * itemsPerPage;
        const newItems = itemsFiltered.slice(startPosition, startPosition + itemsPerPage);
        const pageCount = Math.ceil(itemsFiltered.length / itemsPerPage);

        setPagedItems(newItems);
        setPageCount(pageCount);
    };

    useEffect(() => {
        selectPage();
    }, [items, itemsPerPage, pageNumber, filter, searchText]);

    return [pagedItems, pageCount];
};
